import { type ToastMessageOptions } from 'primevue';

export enum ToastMessageType {
  ERROR = 'error',
  WARNING = 'warn',
  INFO = 'info',
  SUCCESS = 'success'
}

export function useShowToast() {
  const toast = useToast();

  const showToast = (
    message: string,
    options?: ToastMessageOptions & { onClose?: () => void }
  ) => {
    const onCloseCallback = options?.onClose;
    const lifeDuration = options?.life ?? 3000; // Default life duration from PrimeVue

    if (onCloseCallback) {
      delete options.onClose;

      // Execute callback after toast auto-closes
      setTimeout(() => {
        onCloseCallback();
      }, lifeDuration);
    }

    toast.add({
      summary: message,
      severity: 'success',
      ...options
    });
  };

  return {
    showToast
  };
}
